export default __webpack_public_path__ + "static/media/avatar-7.d344e33d.png";